const Clone = function() {
  return JSON.parse(JSON.stringify.apply(this, arguments))
}

export { Clone }
